export const addInitialValues = {
  areaName: '',
};
